module.exports = __webpack_public_path__ + "static/media/4.97bcd41e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/minsk/4.jpg
// module id = 230
// module chunks = 0